import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSupportInsightMetrics = {
  name: "getSupportInsightMetrics" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    windowDays: z.number(),
    aiResolved: z.number(),
    humanResolved: z.number(),
    aiMedianResolutionMs: z.number(),
    humanMedianResolutionMs: z.number(),
    channels: z.array(z.object({ channel: z.string(), count: z.number() })),
  }),
};
